// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2p5mE","footer":"Form_footer__3vQ6S"};